export default __webpack_public_path__ + "static/media/redpay.4a493cd1.svg";